import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';

export default class TpClientPaymentAppliedReportSearchParams extends SearchParamsBase {
  initialize() {
    this.OfficeIds = [];
    this.ClientNameOrId = '';
    this.PaymentTypes = [];
    this.UseEntryDateRange = false;
    this.EntryBefore = dateTimeHelper.indefiniteDateValue();
    this.EntryAfter = dateTimeHelper.indefiniteDateValue();
    this.PaymentRef = '';
    this.AmountPaidMoreThan = '';
    this.AmountPaidLessThan = '';
    this.Reversed = '';
    this.PaymentIdsString = '';
    this.SearchType = 'applied';
  }

  static fieldsInSearchBox = [
    { fieldName: 'ClientNameOrId', label: 'Client Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'UseEntryDateRange',
      label: 'Entry Date Range',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'EntryAfter',
      label: 'Entry On or After',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseEntryDateRange,
    },
    {
      fieldName: 'EntryBefore',
      label: 'Entry On or Before',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseEntryDateRange,
    },
    {
      fieldName: 'PaymentIdsString',
      label: 'Payment IDs (id1,id2,id3...)',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'PaymentTypes',
      label: 'Payment Method',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 53,
    },
    { fieldName: 'PaymentRef', label: 'Payment Ref.', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'Reversed', label: 'Reversed?', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    {
      fieldName: 'AmountPaidLessThan',
      label: 'Amount Paid Less Than',
      className: 'col-4',
      type: InputTypesEnum.Number,
    },
    {
      fieldName: 'AmountPaidMoreThan',
      label: 'Amount Paid More Than',
      className: 'col-4',
      type: InputTypesEnum.Number,
    },
    {
      fieldName: 'OfficeIds',
      label: 'Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'TpClientPaymentAppliedReportSearchParams';
}
